import { render, staticRenderFns } from "./settingsPanels.vue?vue&type=template&id=00a85a70&scoped=true"
import script from "./settingsPanels.vue?vue&type=script&lang=js"
export * from "./settingsPanels.vue?vue&type=script&lang=js"
import style0 from "./settingsPanels.vue?vue&type=style&index=0&id=00a85a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a85a70",
  null
  
)

export default component.exports